import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import multi from 'redux-multi';
import promiseMiddleware from 'redux-promise-middleware';

import rootReducer from '../reducers';

const composeEnhancers = (
  process.env.NODE_ENV !== 'sd'
  && typeof window === 'object'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
)
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
  : compose;

export default (initialState) => {
  return createStore(rootReducer, initialState,
    composeEnhancers(applyMiddleware(thunk, promiseMiddleware(), multi)));
};



// WEBPACK FOOTER //
// ./src/components/storefront/store/configureStore.js